import { message } from "antd";
import { GET, POST, PUT } from "../../../services/api";
import { ApiUrl } from "../../../ApiHelper/ApiUrl";
import { clientTypes } from "../../type/clientTypes";
import { toast } from "react-toastify";
import { cleanObject } from "../../../utils/commonFunctions";

export const getAdvData = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: clientTypes.GET_ADV_DATA_PENDING,
        isLoading: true,
      });
      const cleanedPayload = cleanObject(payload);
      const res = await GET(`${ApiUrl.CLIENT_ADV_DATA_GET}`, cleanedPayload);
      dispatch({
        type: clientTypes.GET_ADV_DATA_SUCCESS,
        payload: res.data?.result ?? [],
        isLoading: false,
        msg: res.data.message ?? "",
      });
    } catch (error) {
      dispatch({
        type: clientTypes.GET_ADV_DATA_FAILED,
        payload: [],
        isLoading: false,
        msg: (error && error?.message) ?? "",
      });
    }
  };
};

export const getAdvDetailsData = (index) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: clientTypes.GET_ADV_DETAILS_DATA_PENDING,
        isLoading: true,
      });
      const id = `advertisement_id=${index}`;
      const res = await GET(`${ApiUrl.CLIENT_ADV_DETAILS_DATA_GET}/?${id}`);
      dispatch({
        type: clientTypes.GET_ADV_DETAILS_DATA_SUCCESS,
        payload: res.data?.result ?? [],
        isLoading: false,
        msg: res.data.message ?? "",
      });
    } catch (error) {
      dispatch({
        type: clientTypes.GET_ADV_DETAILS_DATA_FAILED,
        payload: [],
        isLoading: false,
        msg: (error && error?.message) ?? "",
      });
    }
  };
};

export const addAdvertisement = (values, callback) => {
  return async () => {
    const res = await POST(`${ApiUrl.CLIENT_ADV_POST}`, values);
    if (res?.data?.code === 201) {
      toast.success(res?.data?.message);
      callback();
    } else {
      toast.error(res?.data?.message);
    }
  };
};

export const updateAdv = (_id, values, callback) => {
  return async () => {
    const id = `advertisement_id=${_id}`;
    const res = await PUT(`${ApiUrl.CLIENT_ADV_POST}/?${id}`, values);
    if (res?.data?.code === 200) {
      toast.success(res?.data?.message);
      callback(res);
    } else {
      toast.error(res?.data?.message);
    }
  };
};
